import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ApiEnum} from "../../../@application/enum/api.enum";
import {ApiBaseService} from "../../../../../projects/vendors/src/lib/services/api-base.service";
import {MatDialogRef} from "@angular/material/dialog";
import {StorageService} from "../../../../../projects/vendors/src/lib/services/storage.service";
import {RestaurantDetail} from "../../../@domain/resturant-detail";

@Component({
    selector: 'app-start-day-dialog',
    templateUrl: './start-day-dialog.component.html',
    styleUrl: './start-day-dialog.component.scss',
    standalone: false
})
export class StartDayDialogComponent implements OnInit {
  startDayFrom!: FormGroup;
  private apiBaseService = inject(ApiBaseService);
  private storageService = inject(StorageService)
  private dialogRef = inject(MatDialogRef<StartDayDialogComponent>);
  restaurantDetails = {} as RestaurantDetail
  toDay = new Date()

  ngOnInit() {
    this.formInit();
    this.restaurantDetails = this.storageService.getFromSessionStorage('restaurantDetail');
    if (this.restaurantDetails && this.restaurantDetails.dayEndInfo) {
      const startTimeParts = this.restaurantDetails.dayEndInfo.startTimeIn24H.split(':').map(Number);
      const nowHourAndMinutes = this.toDay.getHours() * 60 + this.toDay.getMinutes();
      const endHourAndMinutes = startTimeParts[0] * 60 + startTimeParts[1];
      if (nowHourAndMinutes >= endHourAndMinutes) {
        const startedTime = new Date(this.toDay.getFullYear(), this.toDay.getMonth(), this.toDay.getDate(), ...startTimeParts);
        this.startDayFrom.get('startTime')?.setValue(startedTime);
      } else {
        this.startDayFrom.get('startTime')?.setValue(this.toDay);
      }
    }
  }

  private formInit() {
    this.startDayFrom = new FormGroup({
      startTime: new FormControl(null, Validators.required),
      startCash: new FormControl(null, Validators.required)
    });
  }

  onSubmit() {
    if (this.startDayFrom.valid) {
      this.apiBaseService.POST_API([ApiEnum.RestaurantModule, ApiEnum.DailySession, ApiEnum.Start], this.startDayFrom.value)
        .subscribe({
          next: () => {
            // the start endpoint returns 204, so the body carries nothing - close with an
            // explicit success flag, otherwise the caller can't tell success from cancel
            this.dialogRef.close(true)
          }
        })
    } else {
      Object.values(this.startDayFrom.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({onlySelf: true})
        }
      })
    }
  }
}
